import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9460edf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-modal-content" }
const _hoisted_2 = { class: "navigation-modal-content-item" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" take me to their dashboard ")
const _hoisted_4 = { class: "navigation-modal-content-item" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" close modal ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    title: _ctx.modalTitle,
    isOpen: _ctx.isOpen
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goToDashboard'))),
            primary: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_base_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
            transparent: ""
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isOpen"]))
}